module.exports = __webpack_public_path__ + "images/backgrounds/mountain/full.7de5ee0e23bb92584a44.jpg";